import Entity from "./Entity";

export default class Application extends Entity {
    constructor(data) {
        super(data);
    }

    getId() {
        return this.get("id");
    }

    getName() {
        return this.get("name");
    }
}